export default __webpack_public_path__ + "static/media/Country.71819640.mp3";